<div class="privacy">
	<header>Privacy Policy</header>
	<p>
		Your privacy is important to us. It is our policy to respect your privacy regarding any
		information we may collect from you when you visit https://loremquotesum.com/ (the Site).
	</p>
	<p>
		In a nutshell, we only ask for personal information when we truly need it to provide a service
		to you. We collect it by fair and lawful means, with your knowledge and consent. We also let you
		know why we’re collecting it and how it will be used. Lorem Quotesum only needs your first name,
		last name, and email address. Also we use Google Analytics to understand how users are using the
		Site.
	</p>
	<h2>PERSONAL INFORMATION WE COLLECT</h2>
	<p>
		When you visit the Site, we automatically collect certain information about your device,
		including information about your web browser, IP address, time zone, and some of the cookies
		that are installed on your device. Additionally, as you browse the Site, we collect information
		about what websites or search terms referred you to the Site, and information about how you
		interact with the Site. We refer to this automatically-collected information as “Device
		Information.”
	</p>
	<p>We collect Device Information using the following technologies:</p>
	<ul>
		<li>
			“Cookies” are data files that are placed on your device or computer and often include an
			anonymous unique identifier. For more information about cookies, and how to disable cookies,
			visit http://www.allaboutcookies.org.
		</li>
		<li>
			“Log files” track actions occurring on the Site, and collect data including your IP address,
			browser type, Internet service provider, referring/exit pages, and date/time stamps.
		</li>
		<li>
			“Web beacons,” “tags,” and “pixels” are electronic files used to record information about how
			you browse the Site.
		</li>
	</ul>
	<h2>HOW DO WE USE YOUR PERSONAL INFORMATION?</h2>
	<p>We use the information that we collect generally to:</p>
	Communicate with you; Investigate problems; Screen interactions for potential risk or fraud; and Enforce
	security and data privacy rules within the extension
	<p>
		We use the Device Information that we collect to help us screen for potential risk and fraud (in
		particular, your IP address), and more generally to improve and optimize our Site (for example,
		by generating analytics about how our customers interact with the Site and the Browser
		Extension, review error reports, and to assess the success of our marketing and advertising
		campaigns).
	</p>
	<h2>SHARING YOUR PERSONAL INFORMATION</h2>
	<p>
		We do not share your Personal Information unless required by the government to comply with
		applicable laws and regulations, to respond to a subpoena, search warrant or other lawful
		request for information we receive, or to otherwise protect our rights.
	</p>
	<h2>YOUR RIGHTS</h2>
	<p>
		If you are a European resident, you have the right to access personal information we hold about
		you and to ask that your personal information be corrected, updated, or deleted. If you would
		like to exercise this right, please contact us through the contact information below.
	</p>
	<p>
		Additionally, if you are a European resident please note that your information will be
		transferred outside of Europe, including to Canada and the United States.
	</p>
	<h2>DATA RETENTION</h2>
	<p>
		We will maintain your login information for our records unless and until you ask us to delete
		this information.
	</p>
	<h2>CHANGES</h2>
	<p>
		We may update this privacy policy from time to time in order to reflect, for example, changes to
		our practices or for other operational, legal or regulatory reasons.
	</p>
	<h2>CONSENT</h2>
	<p>
		By using the Site, you hereby consent to this <a href="/privacy">Privacy Policy</a> and agree to
		its Terms and Conditions.
	</p>
	<p>This policy is effective as of June 1, 2023.</p>
	<h2>CONTACT US</h2>
	<p>
		For more information about our privacy practices, if you have questions, or if you would like to
		make a complaint, please contact us by e-mail at help@loremquotesum.com.
	</p>
</div>

<style>
	.privacy {
		padding: 0 1rem 1rem 1rem;
	}
	header {
		text-align: center;
		font-size: 2rem;
		font-weight: bold;
		margin-bottom: 1rem;
	}
	h2 {
		font-size: 1.5rem;
		margin-top: 0.5rem;
	}
	p,
	ul {
		padding-top: 0.75rem;
	}
	li {
		list-style: bullet;
		list-style-position: inside;
		padding-left: 0.5rem;
	}
	a {
		text-decoration: underline;
	}
</style>
